"use client";

import { useCategories } from "@/app/hooks/use-categories";
import { CategoriesPage } from "@/app/components/layout/categories-page";
import { AlbumsPageSkeleton } from "@/app/components/skeletons/page-skeletons";

export default function AlbumsPage() {
  const { categories, isLoading } = useCategories();

  if (isLoading) {
    return <AlbumsPageSkeleton />;
  }

  return (
    <CategoriesPage
      title="Albümler"
      description="En güzel anılarınız için profesyonel albüm seçenekleri"
      items={categories?.categories || []}
      baseUrl="/albumler"
      isLoading={isLoading}
    />
  );
}